import type { FunctionComponent } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useContent } from "@/modules/jobSearchPrefiltered/hooks/useContent"
import { getLocalizedContentKeysForSlug } from "@/modules/jobSearchPrefiltered/utils/getLocalizedContentKeysForSlug"

type ResultsTitleProps = {
  displayCount?: boolean
  jobAdsCount: number
}

export const ResultsTitle: FunctionComponent<ResultsTitleProps> = ({ jobAdsCount, displayCount }) => {
  const { t } = useTranslation(["job_search_prefiltered"])
  const { data } = useContent()

  if (!data) {
    return null
  }

  const { subtitle } = getLocalizedContentKeysForSlug(data.currentSlug)

  let subtitleTranslation = t(subtitle, { ...data.currentSlug.params, count: jobAdsCount })

  if (!displayCount) {
    // We replace the count when it's handled by the parent component
    subtitleTranslation = subtitleTranslation.replace(new RegExp(`^${jobAdsCount}\\s+`), "")
  }

  return <span data-testid="PrefilteredJobSearch-ResultsTitle">{subtitleTranslation}</span>
}
